module.exports = __webpack_public_path__ + "img/erweima-jpg-02.4c158717.png";